import { useMutation } from "react-query";
import { endpoints } from "utils/endpoints";
import http from "utils/http";

const addSubscribe = (postData) => {
  return http().post(endpoints.forms.subscribe, postData);
};

export function useSubscribe() {
  return useMutation(addSubscribe, {
    onError: (errorData) => {
      const errorMessage = errorData?.error?.message || errorData?.message;
      alert(errorMessage);
    },
  });
}
